import axios from 'axios';
import axiosJsonp from 'axios-jsonp';
import epgData from './mocks/epgData';
import moviesData from './mocks/carouselBannerData';
import moment from 'moment';
import grinch from '../assets/images/shows/grinch.png';
import categories from './mocks/categories';
import packages from './mocks/packages';
import genres from '../data/mocks/genres';
import platforms from '../data/mocks/platforms';
import headerFooter from '../data/mocks/header2';
import settings from '../settings';

const maxRetry = 3;
const mockResponses = false;

let url = '/api';

const axiosInstance = axios.create({
  baseURL: url,
  timeout: 15000,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// fetch('/config.json')
//   .then((response) => response.json())
//   .then((data) => {
//     // axios can't accept relative base urls, we construct absolute when needed
//     const url = data.apiUrl.startsWith('http') ? data.apiUrl : window.location.href + data.apiUrl;
//     axiosInstance = axios.create({
//       baseURL: window.apiUrl,
//       timeout: 15000,
//       headers: {
//         accept: 'application/json',
//         'Content-Type': 'application/json',
//       },
//     });
//   });

let axiosHeader =
  process.env.NODE_ENV === 'production'
    ? axios.create({
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    : axios.create({
      adapter: axiosJsonp,
      headers: {
        accept: 'application/jsonp',
        'Content-Type': 'application/jsonp',
      },
    });

const getChannelById = async (id, count = 0) => {
  if (mockResponses) {
    const result = {
      data: { ...epgData.find((channel) => channel.id === id) },
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 2500);
    });
  }

  try {
    return await axiosInstance.get(`/epg/channels/${id}`);
  } catch (error) {
    if (maxRetry > count + 1) return await getChannelById(id, count + 1);
    throw error;
  }
};

const getChannels = async (dateOffset = 0, channelsOnly = false, count = 0) => {
  const filter = moment().add(dateOffset, 'days');

  if (mockResponses) {
    const result = {
      data: epgData.map((channel) => ({
        ...channel,
        schedule: [channel.schedule.find((schedule) => schedule.date === filter.format('DD.MM.YYYY'))],
      })),
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 2500);
    });
  }

  try {
    const apiFilter = filter.format('YYYY-MM-DD');
    if (channelsOnly) return await axiosInstance.get(`/epg/channels?onlyChannels=true`);
    else return await axiosInstance.get(`/epg/channels?startDate=${apiFilter}&endDate=${apiFilter}`);
  } catch (error) {
    if (maxRetry > count + 1) return await getChannels(dateOffset, channelsOnly, count + 1);
    return { status: error.response.status };
  }
};

const getShowById = async (id, count = 0) => {
  if (mockResponses) {
    const result = {
      data: {
        originalTitle: 'How the Grinch Stole Christmas',
        tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
        scores: [7.2, 7.5],
        image: grinch,
        description:
          'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
        director: 'Ron Howard',
        cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
      },
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 2500);
    });
  }

  try {
    return await axiosInstance.get(`/epg/program/${id}`);
  } catch (error) {
    if (maxRetry > count + 1) return await getShowById(id, count + 1);
    throw error;
  }
};

const getCategories = async (count = 0) => {
  if (mockResponses) {
    const result = {
      data: categories,
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 2500);
    });
  }

  try {
    return await axiosInstance.get('/epg/categories');
  } catch (error) {
    if (maxRetry > count + 1) return await getCategories(count + 1);
    throw error;
  }
};

const getPackages = async (count = 0) => {
  if (mockResponses) {
    const result = {
      data: packages,
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 2500);
    });
  }

  try {
    return await axiosInstance.get('/epg/packages');
  } catch (error) {
    if (maxRetry > count + 1) return await getPackages(count + 1);
    throw error;
  }
};

const getTrendingMovies = async (count = 0) => {
  if (mockResponses) {
    const result = {
      data: [...moviesData],
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 1500);
    });
  }

  try {
    return await axiosInstance.get('/vod?returnpaginginformation=false&page=1&vodtype=TVOD&onlytrending=true');
  } catch (error) {
    if (maxRetry > count + 1) return await getTrendingMovies(count + 1);
    throw error;
  }
};

const getMovieGenres = async (count = 0) => {
  if (mockResponses) {
    const result = {
      data: genres,
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 1500);
    });
  }

  try {
    return await axiosInstance.get('/vod/categories');
  } catch (error) {
    if (maxRetry > count + 1) return await getMovieGenres(count + 1);
    throw error;
  }
};

const getProviders = async (count = 0) => {
  if (mockResponses) {
    const result = {
      data: platforms,
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 1500);
    });
  }

  try {
    return await axiosInstance.get('/vod/platforms');
  } catch (error) {
    if (maxRetry > count + 1) return await getProviders(count + 1);
    throw error;
  }
};

const getHeaderFooterData = async () => {
  if (mockResponses) {
    return {
      data: headerFooter,
      status: 200,
    };
  }

  return await axiosHeader.get(settings.headerUrl);
};

const getMovies = async (search, filter, limit = 100, platform = 'TVOD', provider, page = 1, usePaging = false, count = 0) => {
  if (mockResponses) {
    const result = {
      data: [...moviesData],
      status: 200,
    };

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result);
      }, 1500);
    });
  }

  // default query without search parameters
  let uri = `/vod?returnpaginginformation=${usePaging}&page=${page}&vodtype=${platform}&pagesize=${limit}`;

  if (provider) uri = `${uri}&platform=${provider}`;

  if (search?.length || filter?.length) {
    uri = `/vod?returnpaginginformation=${usePaging}&page=${page}&vodtype=${platform}&TitleFuzzy=${search}&Genre=${filter}`;
  }

  try {
    return await axiosInstance.get(uri);
  } catch (error) {
    if (maxRetry > count + 1) {
      return await getMovies(search, filter, limit, platform, provider, page, usePaging, count + 1);
    }
    throw error;
  }
};

const apiClient = {
  getChannels,
  getChannelById,
  getShowById,
  getCategories,
  getPackages,
  getMovies,
  getTrendingMovies,
  getMovieGenres,
  getProviders,
  getHeaderFooterData,
};

export default apiClient;
